import { Component } from '@angular/core';

@Component({
    selector: 'app-loader-image',
    imports: [],
    templateUrl: './loader-image.component.html',
    styleUrl: './loader-image.component.scss'
})
export class LoaderImageComponent {

}
